import React from "react";
import { Button, CircularProgress } from "@mui/material";

const SecondaryButton = ({
  children,
  isLoading,
  disabled,
  startIcon,
  sx,
  ...props
}) => {
  return (
    <Button
      variant="outlined"
      disabled={isLoading || disabled}
      startIcon={isLoading ? undefined : startIcon}
      sx={{
        fontWeight: 600,
        borderRadius: "8px",
        textTransform: "none",
        height: "45px",
        borderColor: "#85888d",
        color: "#475569",
        "&:hover": {
          backgroundColor: "#f1f5f9",
          borderColor: "#94a3b8",
        },
        ...sx,
      }}
      {...props}
    >
      {isLoading ? <CircularProgress size={20} color="inherit" /> : children}
    </Button>
  );
};

export default SecondaryButton;
